// EventsListPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const EventsListPage = () => <ComingSoon title="Events list" description="See all hotel events." />;

export default EventsListPage;
